module.exports = "https://web-assets-production.autolist.com/_next/static/images/car-graph-8965e799834d51f2ac9437acd0ef2a5a.png";